import { Box } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { MysteryBoxItemDropType } from '../../state/items/items.types';
import ShopMisteryBoxInfoItem from '../ShopMisteryBoxInfoItem/ShopMisteryBoxInfoItem';

function ShopMisteryBoxInfoItemList({
  items,
}: {
  items: MysteryBoxItemDropType[];
}) {
  return (
    <Box gap="space-300">
      {items.map((item, i) => (
        <ShopMisteryBoxInfoItem key={i} {...item} />
      ))}
    </Box>
  );
}

export default memo(ShopMisteryBoxInfoItemList);
